import { useEffect, useMemo, useState } from "react";
import styles from "./ActiveRoles.module.css";
import { DASHBOARD_ROLES_TABLE_OPTIONS } from "../../../constant";
import DataTableWithFilters from "../../CommonComponents/DataTableWithFilters";
import { IoEyeOutline } from "react-icons/io5";
import moment from "moment";
import { HiOutlineDotsVertical } from "react-icons/hi";
import useNotification from "../../../hooks/useNotification";
import DashboardServices from "../../../services/DashboardServices";
import { formatNumbers } from "../../../utils/NumberFormat";

const ActiveRoles = () => {
  const [counts, setCounts] = useState(0);
  const [selectedTab, setSelectedTab] = useState("All");
  const [searchInput, setSearchInput] = useState("");
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState();
  const [prevPage, setPrevPage] = useState();
  const [total, setTotal] = useState(100);

  const fetchUserOverviewData = async (nextPage, prevPage, isBackward) => {
    setLoading(true);

    let queryParams = [`pageSize=10`];

    if (nextPage) queryParams.push(`nextPage=${nextPage}`);
    if (prevPage) queryParams.push(`prevPage=${prevPage}`);
    if (selectedTab && selectedTab !== "All") queryParams.push(`status=${selectedTab}`);
    if (searchInput) queryParams.push(`search=${searchInput}`);

    let str = queryParams.join("&");

    const res = await DashboardServices.getActiveRoles(str);

    if (res) {
      if (res.statusCode === 1) {
        setData(res.data);
        setTotal(res.total);
        setNextPage(res.nextPage);
        setPrevPage(res.prevPage);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } else {
      handleError(`Error: ${res.statusDesc}`);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUserOverviewData();
  }, []);

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const columns = [
    {
      title: `Roles(${counts})`,
      dataIndex: "job_title",
      key: "job_title",
      minWidth: 200,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      minWidth: 120,
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (status, record) => {
        return (
          <div
            className={`${styles.status_cell}  ${styles[`${status.toLowerCase().replace(/ /g, "")}_status`]
              }`}
          >
            {status}
          </div>
        );
      },
    },
    {
      title: "Applicants",
      dataIndex: "candidateCount",
      minWidth: 120,
      key: "candidateCount",
      sorter: (a, b) => a.candidateCount - b.candidateCount,
      render: (candidateCount, record) => {
        return (
          <div className={styles.applicants_cell}>
            <IoEyeOutline />
            {formatNumbers(candidateCount)}
          </div>
        );
      },
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      minWidth: 120,
      sorter: (a, b) => a.department.localeCompare(b.department),
      render: (department, record) => {
        return <div className={styles.tag_cell}>{department}</div>;
      },
    },
    {
      title: "division",
      dataIndex: "division",
      key: "division",
      minWidth: 120,
      sorter: (a, b) => a.division.localeCompare(b.division),
      render: (division, record) => {
        return <div className={styles.tag_cell}>{division}</div>;
      },
    },
    {
      title: "Posted",
      dataIndex: "start_date",
      key: "start_date",
      minWidth: 130,
      sorter: (a, b) => a.start_date.localeCompare(b.start_date),
      render: (start_date, record) => {
        return <div>{moment(new Date(start_date)).format("YYYY.MM.DD")}</div>; // just for decoration
      },
    },
    {
      title: "Deadline",
      dataIndex: "end_date",
      key: "end_date",
      minWidth: 130,
      sorter: (a, b) => a.end_date.localeCompare(b.end_date),
      render: (end_date, record) => {
        return <div>{moment(new Date(end_date)).format("YYYY.MM.DD")}</div>; // just for decoration
      },
    },
    {
      title: "",
      dataIndex: "Actions",
      key: "Actions",
      minWidth: 50,
      render: (status, record) => {
        return (
          <div>
            <HiOutlineDotsVertical />
          </div>
        );
      },
    },
  ];

  const handleTabChange = (value) => {
    setSelectedTab(value);
  };

  const handleSearch = (value) => {
    setSearchInput(value);
  };

  const handlePageChange = (isNextPage) => {
    if (isNextPage) {
      fetchUserOverviewData(nextPage, '', false);
    } else {
      fetchUserOverviewData("", prevPage, true);
    }
  };

  useEffect(() => {
    fetchUserOverviewData();
  }, [selectedTab, searchInput]);

  return (
    <div className={styles.content_wrap}>
      <DataTableWithFilters
        title={"Active Roles posted"}
        columns={columns}
        selectedTab={selectedTab}
        onTabChange={handleTabChange}
        tabOptions={DASHBOARD_ROLES_TABLE_OPTIONS}
        data={data}
        loading={loading}
        handleSearch={handleSearch}
        setCounts={setCounts}
        tableKey={"key"}
        scroll={{
          x: "max-content",
        }}
        pageSize={10}
        total={total}
        handlePageChange={handlePageChange}
      />
    </div>
  );
};

export default ActiveRoles;
